import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import router from '@/router';
import store from '@/store';
import { getCookie } from '@/utils/cookies';
import { getURL } from '@/service/http';
/*
кастомный стор для грида.
props:
    key,
    args = {
         db_schema_name,
         db_view_name,
         token,
         storeName - имя стора , где лежит мета,
         stateMetaName - название массива мета даты
    },
    api
 */
export const gridCardStore = (storeArgs, api) => {
    return AspNetData.createStore({
        loadMethod: 'POST',
        key: storeArgs.key,
        loadUrl: getURL('api'),
        requireTotalCount: true,
        onLoaded: result => {
            if (!Array.isArray(result)) {
                router.push({
                    name: 'loginForm',
                });
            }
        },
        onBeforeSend: (e, ajax) => {
            const data = ajax.data;
            // const apiPath = `meta./${storeArgs.uiId}/data/get`
            // console.log(apiPath)
            const meta = store.state.registryGrid.regGrid;
            ajax.data.args = JSON.stringify({
                db_schema_name: storeArgs.db_schema_name,
                db_view_name: storeArgs.db_view_name,
                ...data,
                appId: getCookie('app'),
                depId: getCookie('dep'),
                token: getCookie('token'),
                meta: meta,
            });
            ajax.data.api = api;
        },
    });
};
